import { type GetVitalSignsResponse, LaboratoryApi, type VitalsPeriod } from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class LaboratoryService {
  static readonly laboratoryApi = new LaboratoryApi(globalApiConfig)

  static async getLaboratoryVitalSigns(
    id: string,
    period: VitalsPeriod,
    shareCode: string | undefined
  ): Promise<GetVitalSignsResponse> {
    return (
      await LaboratoryService.laboratoryApi.getLaboratoryInPeriod(id, period, undefined, shareCode)
    ).data
  }

  static async getLatestLaboratoryValues(
    id: string,
    shareCode: string | undefined
  ): Promise<GetVitalSignsResponse> {
    return (
      await LaboratoryService.laboratoryApi.getLatestLaboratoryVitalSigns(
        id,
        ['LACTATE', 'PH', 'GFR'],
        shareCode
      )
    ).data
  }
}
